export function appendObject ( document ) {
  let wrap = ['body', 'head'];
  if( !document ){
    return "head";
  }

  if (wrap.indexOf(document) === -1) {
    document = 'head';
  }

  return document;
}

export function verifyUrl ( url, etc ) {
  if( !url ){
    return false;
  }

  if( etc === "css" && !url.match(/^https?\:\/\/.+\.css$/) ){
    return false
  }


  if( etc === "js" && !url.match(/^https?\:\/\/.+\.js$/) ){
    return false
  }

  return url

}

export function appendScript (url, documentScript, callback) {

  let _documentScript = appendObject( documentScript );
  let _url = verifyUrl( url );

  if( !_documentScript || !_url ){
    return false;
  }

  let script = document.createElement( "script" );
  script.type = "text/javascript";
  script.text = _url;
  document.getElementsByTagName( _documentScript )[0].appendChild( script );

  if( callback ){
    callback();
  }

}

export function appendStyleSheets (url, documentStyle) {

  let _documentStyle = appendObject( documentStyle );
  let _url = verifyUrl( url );

  if( !_documentStyle || !_url ){
    return false;
  }

  let link = document.createElement('link');
  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.href = _url;
  document.getElementsByTagName( _documentStyle )[0].appendChild(link);

}


// WEBPACK FOOTER //
// ./common/Utils/appendFilesUtil.js